/* The ContxtIQ mark: one flat SVG painted through a mask, so it takes the
   surrounding text color in both themes instead of shipping two rasters.

   `url()` is left for the Rails asset pipeline: esbuild is told to treat image
   paths as external (see `--external:*.svg` in package.json), so the reference
   survives into the bundled CSS, where Propshaft rewrites it to the digested
   /assets path. Logical filename, no directory — same as any Rails
   stylesheet. */
.mark {
  display: block;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background-color: currentColor;
  -webkit-mask-image: url("contxtiq-mark.svg");
  mask-image: url("contxtiq-mark.svg");
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
